export function ParticleField() {
  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i, left: `${Math.random() * 100}%`,
    delay: `${Math.random() * 10}s`, duration: `${8 + Math.random() * 12}s`,
    size: `${2 + Math.random() * 3}px`,
  }));
  return (
    <div className="fixed inset-0 z-[2] pointer-events-none overflow-hidden">
      {particles.map(p => (
        <div key={p.id} className="puzzle-particle"
          style={{ left: p.left, bottom: '-10px', animationDelay: p.delay, animationDuration: p.duration, width: p.size, height: p.size }} />
      ))}
    </div>
  );
}
